// import React, { useState } from "react";

// const ShiftTimingForm = ({
//   loading,
//   closeModal,
//   onSubmit,
//   initialValues,
//   errors = {}, // Added errors prop to display validation messages
// }) => {
//   const [formData, setFormData] = useState(initialValues);

//   // console.log(formData)

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

// //   const handleSubmit = (e) => {
// //     e.preventDefault();

// //     const submissionData = new FormData(); // Use FormData for file upload
// //     submissionData.append("name", formData.name);
// //     submissionData.append("description", formData.description);

// //     onSubmit(submissionData); // Pass the FormData to the parent onSubmit handler
// //   };

//     const handleSubmit = (e) => {
//         e.preventDefault();
    
//         const formatTime = (time) => (time ? `${time}:00` : "");
    
//         const submissionData = new FormData();
//         submissionData.append("name", formData.name);
//         submissionData.append("description", formData.description);
//         submissionData.append("start_time", formatTime(formData.start_time));
//         submissionData.append("end_time", formatTime(formData.end_time));
    
//         onSubmit(submissionData); // Pass FormData to parent handler
//     };
  

//   return (
//     <form onSubmit={handleSubmit} className="space-y-4">
//         {/* Shift Name Field */}
//         <div>
//             <label htmlFor="name" className="block text-sm font-medium text-gray-700">
//             Shift Name
//             </label>
//             <input
//             type="text"
//             id="name"
//             name="name"
//             value={formData.name}
//             onChange={handleChange}
//             className={`mt-1 block w-full border rounded-md p-2 ${
//                 errors.name ? "border-red-500" : "border-gray-300"
//             }`}
//             required
//             />
//             {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
//         </div>

//       {/* Start Time Field */}
//       <div>
//         <label htmlFor="start_time" className="block text-sm font-medium text-gray-700">
//           Start Time
//         </label>
//         <input
//           type="time"
//           id="start_time"
//           name="start_time"
//           value={formData.start_time}
//           onChange={handleChange}
//           className={`mt-1 block w-full border rounded-md p-2 ${
//             errors.start_time ? "border-red-500" : "border-gray-300"
//           }`}
//           required
//         />
//         {errors.start_time && <p className="text-red-500 text-sm mt-1">{errors.start_time}</p>}
//       </div>

//         {/* End Time */}
//         <div>
//             <label htmlFor="end_time" className="block text-sm font-medium text-gray-700">
//             End Time
//             </label>
//             <input
//             type="time"
//             id="end_time"
//             name="end_time"
//             value={formData.end_time}
//             onChange={handleChange}
//             className={`mt-1 block w-full border rounded-md p-2 ${
//                 errors.end_time ? "border-red-500" : "border-gray-300"
//             }`}
//             required
//             />
//             {errors.end_time && <p className="text-red-500 text-sm mt-1">{errors.end_time}</p>}
//         </div>

//       {/* description Field */}
//       <div>
//         <label htmlFor="description" className="block text-sm font-medium text-gray-700">
//           Description
//         </label>
//         <textarea
//           type="text"
//           id="description"
//           name="description"
//           value={formData.description}
//           onChange={handleChange}
//           className={`mt-1 block w-full border rounded-md p-2 ${
//             errors.description ? "border-red-500" : "border-gray-300"
//           }`}
//           required
//         />
//         {errors.description && <p className="text-red-500 text-sm mt-1">{errors.description}</p>}
//       </div>


//       {/* Form Actions */}
//       <div className="flex justify-end space-x-4">
//         <button
//           type="button"
//           onClick={closeModal}
//           className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
//         >
//           Cancel
//         </button>
//         <button
//           type="submit"
//           className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
//         >
//         {initialValues.id ? "Update Shift-Timing" : "Add Shift-Timing"}
//           {loading && (
//             <svg
//               className="animate-spin h-5 w-5 ml-2 text-white"
//               xmlns="http://www.w3.org/2000/svg"
//               fill="none"
//               viewBox="0 0 24 24"
//             >
//               <circle
//                 className="opacity-25"
//                 cx="12"
//                 cy="12"
//                 r="10"
//                 stroke="currentColor"
//                 strokeWidth="4"
//               ></circle>
//               <path
//                 className="opacity-75"
//                 fill="currentColor"
//                 d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
//               ></path>
//             </svg>
//           )}
//         </button>
//       </div>
//     </form>
//   );
// };

// export default ShiftTimingForm;


import React, { useState } from "react";

const ShiftTimingForm = ({
  shifts,
  loading,
  closeModal,
  onSubmit,
  initialValues,
  errors = {}, // Added errors prop to display validation messages
}) => {
  const [formData, setFormData] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({}); // Validation errors
  
  // // console.log("Form Data:", formData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const formatTime = (time) => {
    if (!time) return "";
    return time.includes(":") && time.length === 5 ? `${time}:00` : time; // Ensure HH:MM:SS format
  };

  const validate = () => {
    const validationErrors = {};
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const onlyTextRegex = /^[A-Za-z\s-]+$/;

    if (!formData.name.trim()) {
      validationErrors.name = "Name is required.";
    } else if (!onlyTextRegex.test(formData.name.trim())) {
      validationErrors.name = "Name should contain only letters and spaces.";
    }

    if (!formData.description.trim()) {
      validationErrors.description = "Description is required.";
    } else if (!onlyTextRegex.test(formData.description.trim())) {
      validationErrors.description = "Description should contain only letters and spaces.";
    }

    return validationErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setFormErrors(validationErrors);
      return;
    }	

    setFormErrors("")

    const submissionData = new FormData();
    submissionData.append("name", formData.name);
    submissionData.append("description", formData.description);
    submissionData.append("start_time", formatTime(formData.start_time));
    submissionData.append("end_time", formatTime(formData.end_time));

    onSubmit(submissionData); // Pass FormData to parent handler
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 font-poppins">
      {/* Shift Name Field */}
      <div>
        <label htmlFor="name" className="block dark:text-white text-sm font-medium text-gray-700">
          Shift Name <span className="text-red-500 ml-1">*</span>
        </label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name || ""}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            formErrors.name ? "border-red-500" : "border-gray-300"
          }`}
          required
        />
        {formErrors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
      </div>

      {/* Start Time Field */}
      <div>
        <label htmlFor="start_time" className="block dark:text-white text-sm font-medium text-gray-700">
          Start Time <span className="text-red-500 ml-1">*</span>
        </label>
        <input
          type="time"
          id="start_time"
          name="start_time"
          value={formData.start_time || ""}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            errors.start_time ? "border-red-500" : "border-gray-300"
          }`}
          required
        />
        {errors.start_time && <p className="text-red-500 text-sm mt-1">{errors.start_time}</p>}
      </div>

      {/* End Time */}
      <div>
        <label htmlFor="end_time" className="block dark:text-white text-sm font-medium text-gray-700">
          End Time <span className="text-red-500 ml-1">*</span>
        </label>
        <input
          type="time"
          id="end_time"
          name="end_time"
          value={formData.end_time || ""}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            errors.end_time ? "border-red-500" : "border-gray-300"
          }`}
          required
        />
        {errors.end_time && <p className="text-red-500 text-sm mt-1">{errors.end_time}</p>}
      </div>

      {/* Description Field */}
      <div>
        <label htmlFor="description" className="block dark:text-white text-sm font-medium text-gray-700">
          Description 
        </label>
        <textarea
          id="description"
          name="description"
          value={formData.description || ""}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            formErrors.description ? "border-red-500" : "border-gray-300"
          }`}
          required
        />
        {formErrors.description && <p className="text-red-500 text-sm mt-1">{formErrors.description}</p>}
      </div>

      {/* Form Actions */}
      <div className="flex justify-between items-center space-x-4">
        <button
          type="button"
          onClick={closeModal}
          className="px-4 py-2 dark:bg-gray-900 dark:text-white bg-gray-500 text-white rounded-md hover:bg-gray-600"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          {initialValues.id ? "Update" : "Add"}
          {loading && (
            <svg
              className="animate-spin h-5 w-5 ml-2 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              ></path>
            </svg>
          )}
        </button>
      </div>
    </form>
  );
};

export default ShiftTimingForm;
